import appliedMaterials from '../../components/appliedMaterials/appliedMaterials'
import paintCoating from '../../components/paintCoating/paintCoating'
import lubricatingOil from '../../components/lubricatingOil/lubricatingOil'
import agrochemical from '../../components/agrochemical/agrochemical'
import electronicChemical from '../../components/electronicChemical/electronicChemical'
import newEnergy from '../../components/newEnergy/newEnergy'
import chemicalReagent from '../../components/chemicalReagent/chemicalReagent'

export default {
    data() {
        return {
            currentMenu: '/industries/appliedMaterials'
        }
    },
    components: {
        appliedMaterials,
        paintCoating,
        lubricatingOil,
        agrochemical,
        electronicChemical,
        newEnergy,
        chemicalReagent
    },
    created() {
        var route = this.$route.path
        this.currentMenu = route
    },
    watch:{
        //监听路由变化
        $route(to,from){
            console.log(to.path);//到哪去
            var route = to.path
            this.currentMenu = route
        }
      },
    methods: {
        selectMenu(page){
            var route = this.$route.path
            this.currentMenu = page
            if(page != route){
                this.$router.push(page)
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/industries/industries.vue.js